// removed by extract-text-webpack-plugin
module.exports = {"reviewBodyText":"styles__reviewBodyText___2rexg"};


//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/review/styles.css
// module id = VFi5
// module chunks = 2